import React, { useEffect, useState } from 'react';
import { useAuth } from '@/context/AuthContext';

export const AdminCompliance = () => {
  const { api } = useAuth();
  const [o, setO] = useState(null);
  useEffect(() => { api.get('/security/admin/overview').then((r) => setO(r.data)).catch(() => {}); }, [api]);
  if (!o) return null;
  const stats = [['Usuarios', o.users], ['Con doble factor', `${o.users_with_mfa} (${o.mfa_pct}%)`], ['DPA firmados', o.dpa_signed], ['Accesos fallidos hoy', o.failed_logins_today]];
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3" data-testid="admin-compliance">
      {stats.map(([l, v]) => (
        <div key={l} className="p-3 rounded-xl bg-slate-900/50 border border-slate-800">
          <p className="text-xs text-slate-400">{l}</p>
          <p className="text-xl font-bold font-['Outfit']" data-testid={`admin-compliance-${l.replace(/\s+/g, '-').toLowerCase()}`}>{v}</p>
        </div>
      ))}
    </div>
  );
};
